import { useState } from 'react'

import { Box, Divider, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import SavedShiftInformation from 'modules/shift_management/components/ShiftManagement/SavedShiftInformation'
import TooltipIcon from 'modules/shift_management/components/ShiftManagement/TooltipIcon'
import { DefaultShift } from 'modules/shift_management/lib/types'
import TooltipLabel from 'modules/time_planning/components/Breaks/TooltipLabel'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

interface Props {
  defaultShift: DefaultShift
  plannedBreaks: PlannedBreak[]
  onSubmit: () => void
}

const QuickActionsItem = ({ defaultShift, plannedBreaks, onSubmit }: Props) => {
  const [isHover, setIsHover] = useState<boolean>(false)

  const hasPlannedBreaks = !!plannedBreaks?.length
  const hasNotes = defaultShift.notes
  const hasLocation = defaultShift.location
  const hasWorkArea = hasLocation && defaultShift.workArea

  const showIcons = hasPlannedBreaks || hasNotes || hasWorkArea

  const borderColor = isHover ? 'viridian1000' : 'grey400'

  return (
    <Box
      flexDirection="row"
      gap="s8"
      padding="s12"
      borderRadius={{ all: 'abs016' }}
      border={{
        all: {
          style: 'solid',
          width: 's2',
          color: borderColor,
        },
      }}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={() => onSubmit()}
    >
      <SavedShiftInformation
        title={defaultShift.title}
        color={defaultShift.color}
        startAt={defaultShift.startAt}
        endAt={defaultShift.endAt}
        overnightShift={defaultShift.overnightShift}
      >
        {hasLocation && (
          <Box overflowX="hidden">
            <Text size="200" weight="medium" color="grey1000" ellipsis>
              {defaultShift.location.name}
            </Text>
          </Box>
        )}
        {showIcons && (
          <Box flexDirection="row" gap="s4" alignItems="center" paddingBottom="s2">
            {hasPlannedBreaks && (
              <TooltipIcon.Small
                icon="coffee"
                label={
                  <Box flexDirection="column" gap="s4">
                    {plannedBreaks.length > 1 && (
                      <Text size="100" color="grey000White">
                        {plannedBreaks.length} {i18n.t('company_settings.time.breaks.title')}:
                      </Text>
                    )}
                    {plannedBreaks.map((plannedBreak) => (
                      <Box key={plannedBreak.id}>
                        {plannedBreaks.length > 1 && <Divider backgroundColor="grey1000white" />}
                        <Box gap="s4">
                          <TooltipLabel plannedBreak={plannedBreak} timezone="Utc" size="100" />
                        </Box>
                      </Box>
                    ))}
                  </Box>
                }
              />
            )}
            {hasNotes && <TooltipIcon.Small icon="comment" label={defaultShift.notes} />}
            {hasWorkArea && (
              <TooltipIcon.Small icon="space-control" label={defaultShift.workArea.name} />
            )}
          </Box>
        )}
      </SavedShiftInformation>
    </Box>
  )
}

export default observer(QuickActionsItem)
